import React, { useState, useEffect } from "react";
import DarkMode from "./DarkMode";
import ResponsiveMenu from "./ResponsiveMenu";
import { HiMenuAlt3, HiMenuAlt1 } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../config/translation/LanguageSwitcher";

export const MenuLinks = [
	{
		id: 1,
		name: "navbar.home",
		link: "#hero",
	},
	{
		id: 2,
		name: "navbar.services",
		link: "#services",
	},
	{
		id: 3,
		name: "navbar.about",
		link: "#about",
	},
];

const Navbar = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [showMenu, setShowMenu] = useState(false);
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setScrolled(window.scrollY > 50);
		};
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const handleContactClick = () => {
		navigate("/contact-us");
	};

	const toggleMenu = () => {
		setShowMenu(!showMenu);
	};

	const closeMenu = () => {
		setShowMenu(false);
	};

	const handleNavigation = (link) => {
		navigate("/");
		setTimeout(() => {
			const section = document.getElementById(link);
			if (section) {
				section.scrollIntoView({ behavior: "smooth" });
			}
		}, 200);
	};

	return (
		<>
			<nav
				className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
					scrolled
						? "bg-white/95 dark:bg-slate-900/95 backdrop-blur-lg shadow-lg"
						: "bg-cream/90 dark:bg-slate-900/90 backdrop-blur-sm"
				}`}
			>
				<div className="container py-3 md:py-4">
					<div className="flex justify-between items-center">
						{/* Logo */}
						<a
							className="flex items-center gap-3 group"
							href="/"
						>
							<div className="relative">
								<img
									className="w-12 h-12 rounded-xl object-cover shadow-md group-hover:shadow-lg transition-shadow duration-300"
									src="https://res.cloudinary.com/dmwvkjqsn/image/upload/v1715788931/AccountingBusinessCDN/drwj6o0fn7chiqrlstdg.jpg"
									alt={t("navbar.logoAlt")}
								/>
								<div className="absolute inset-0 rounded-xl ring-2 ring-accent/0 group-hover:ring-accent/50 transition-all duration-300"></div>
							</div>
							<span className="text-xl font-bold text-slate-800 dark:text-white">
								{t("navbar.company")}
							</span>
						</a>

						{/* Desktop Menu */}
						<div className="hidden md:block">
							<ul className="flex items-center gap-2">
								{MenuLinks.map(({ id, name, link }) => (
									<li key={id}>
										<a
											href={"/" + link}
											onClick={() => handleNavigation(link)}
											className="relative px-4 py-2 text-base font-medium text-gray-700 dark:text-gray-200 hover:text-accent dark:hover:text-accent transition-colors duration-300 group"
										>
											{t(name)}
											<span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-accent group-hover:w-4/5 group-hover:left-[10%] transition-all duration-300"></span>
										</a>
									</li>
								))}
								<li className="ml-4">
									<button
										onClick={handleContactClick}
										className="primary-btn"
									>
										{t("navbar.contact")}
									</button>
								</li>
								<li className="ml-2">
									<LanguageSwitcher />
								</li>
								<li className="ml-2">
									<DarkMode />
								</li>
							</ul>
						</div>

						{/* Mobile Menu Button */}
						<div className="flex items-center gap-3 md:hidden">
							<DarkMode />
							<button
								onClick={toggleMenu}
								className="p-2.5 rounded-xl bg-accent/10 hover:bg-accent/20 transition-colors duration-200"
								aria-label="Toggle menu"
							>
								{showMenu ? (
									<HiMenuAlt1 className="text-2xl text-accent" />
								) : (
									<HiMenuAlt3 className="text-2xl text-accent" />
								)}
							</button>
						</div>
					</div>
				</div>
			</nav>
			{/* Mobile Menu - Outside nav for proper z-index */}
			<ResponsiveMenu showMenu={showMenu} closeMenu={closeMenu} />
			{/* Spacer for fixed navbar */}
			<div className="h-20"></div>
		</>
	);
};

export default Navbar;
